import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContatoComponent } from './contato.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    ContatoComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    ContatoComponent
  ]
})

export class ContatoModule { }
